import _ from 'lodash'
import React, {useCallback,} from 'react'
import {getResponseItem, LoadingWrapper} from '../../Shared'
import {bindQueryParam, mapPathParam} from '../functions/routerHelper'
import useAsync from "../../../modules/asyncCache/useAsync";
import ProfileEntity from "./ProfileEntity";
import {profile_getById_Api} from "../../../apis";
import {getId} from "../../../apis/model/base";

const ProfileContext = React.createContext({})


export const ProfileProvider = ({
                                    item,
                                    children,
                                    ...props
                                }) => {

    const apiInfo = profile_getById_Api
    const id = typeof item === 'string' ? item : getId(item)

    const cacheId = mapPathParam(apiInfo.path, {id}) + id

    const {response, isLoading = false} = useAsync({
        apiInfo,
        query: bindQueryParam({id}),
        deps: [id]
    })

    const isSucceed = Number(_.get(response, 'status')) === 200

    const cache = getResponseItem(response)

    const error = getResponseItem(response, 'error')

    const errorMessage = _.get(response, 'errorMessages.error')

    const error_code = _.get(response, 'errorMessages.error_code')

    const status = {
        title: getResponseItem(response, 'status'),
        description: errorMessage,
    }


    const renderHeader = useCallback((action, isModal) => null, [])

    return (
        <LoadingWrapper isLoading={!id}>
            <ProfileEntity
                key={cacheId}
                item={id}>
                {(item) => {
                    return (
                        <ProfileContext.Provider
                            value={{
                                id,
                                isLoading,
                                item,
                                error,
                                cache,
                                status,
                                isSucceed,
                                error_code,
                                renderHeader,
                                errorMessage,
                                ...props,
                            }}>
                            {children}
                        </ProfileContext.Provider>
                    )
                }}
            </ProfileEntity>
        </LoadingWrapper>
    )
}

export default ProfileContext
